import { render, staticRenderFns } from "./CreateCompanyForm.vue?vue&type=template&id=21ad902d&scoped=true"
import script from "./CreateCompanyForm.vue?vue&type=script&lang=js"
export * from "./CreateCompanyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ad902d",
  null
  
)

export default component.exports